/**
 * 이 문서가 사라진 뒤 갈 형제의 상세 주소 — **다음 탭 → 없으면 앞 탭**(2026-09-10 사용자 확정).
 *
 * 삭제 후 목적지 판정의 **단일 소스**다. 같은 규칙이 두 자리에서 쓰인다:
 *  - 상세에서 직접 지울 때(`useReportDelete.resolveAfterDeleteHref`)
 *  - **다른 탭·다른 사람**이 지워 이 화면이 이탈할 때(`useReportState.resolveDeletedNavigateHref`)
 * 두 곳이 각자 판정하면 같은 사건에 화면이 다르게 반응한다.
 *
 * 목록 순서는 칩과 같은 생성순이라 「다음」은 화면에서 오른쪽 칸으로 읽히는 문서다. 마지막
 * 탭이 사라지면 왼쪽으로 물러선다 — 「첫 형제로 간다」로 두면 맥락이 맨 앞으로 튄다.
 */
export function resolveSiblingHrefAfterRemoval(
  siblings: ReadonlyArray<{ id: string }>,
  removedId: string | undefined,
): string | null {
  const target = resolveSiblingIdAfterRemoval(siblings, removedId);
  return target ? `/reports/${target}` : null;
}

/**
 * 같은 규칙의 **id** 변형 — 주소가 `/reports/:id`가 아닌 화면(위임 담당자 토큰 페이지는
 * `?reportId=`로 형제를 오간다)이 쓴다. 판정은 위 함수와 한 몸이다(위가 이것을 감싼다).
 */
export function resolveSiblingIdAfterRemoval(
  siblings: ReadonlyArray<{ id: string }>,
  removedId: string | undefined,
): string | null {
  const idx = siblings.findIndex((s) => s.id === removedId);
  // 목록에 자기가 없으면(캐시가 이미 갱신됐거나 형상이 어긋남) 남은 아무 형제로 — 묶음 안에 머문다.
  const target = idx >= 0 ? (siblings[idx + 1] ?? siblings[idx - 1]) : siblings.find((s) => s.id !== removedId);
  return target ? target.id : null;
}
